import { constants  } from './constants';

const APP = {
    Constants: constants
}; 
export default APP;